import React from 'react';

const InfoModal = ({ isOpen, onClose, title, children, width = 'w-96' }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
            <div className={`bg-gray-200 border border-gray-400 ${width}`}>
                {/* 윈도우 타이틀바 */}
                <div className="bg-gradient-to-r from-blue-700 to-blue-300 text-white px-2 py-1 flex justify-between items-center border-gray-400">
                    <span className="text-sm font-bold">{title}</span>
                    <button 
                        onClick={onClose}
                        className="w-5 h-5 bg-gray-300 text-black border border-gray-400 hover:bg-gray-200 font-bold flex items-center justify-center"
                    >
                        -
                    </button>
                </div>
                
                {/* 모달 내용 */}
                <div className="p-4 bg-white border-t border-gray-300">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default InfoModal; 